/**
 * Documents API — multipart upload helper (used by chat attachments).
 */

import { apiFetch } from './core'

/** Multipart upload for chat attachments (same store as visa documents). */
export async function uploadDocumentFile(file) {
    const form = new FormData()
    form.append('file', file)
    return apiFetch('/documents/upload', { method: 'POST', body: form })
}
